import React, { useEffect } from "react";
import Select from "../form/select/Select";
import { getGlAccounts } from "../../redux/slice/accounting/accountingSlice";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { isEmptyObjectValues, objectCheck } from "../../utils/helpers/filter";
import * as Yup from "yup";

const SavingsAccounting = ({ interestRef, settingsRef, setAccounting }) => {
  const { gl_accounts } = useSelector((state) => state.accounting);

  const dispatch = useDispatch();

  const onSubmit = (values) => {
    setAccounting(values);
    settingsRef?.current?.click();
  };

  const validationScehma = Yup.object().shape({
    income_gl: Yup.string("Income GL must be a string").required(
      "Income GL cannot be blank"
    ),
    asset_gl: Yup.string("Asset GL must be a string").required("Asset GL cannot be blank"),
    liability_gl: Yup.string("Policy Portfolio must be a string").required("Policy Portfolio cannot be blank"),
    interest_expense_gl: Yup.string("Interest Expense must be a string").test(
      "not-same-as-commission",
      "Interest Expense must be different from Commission",
      function (value) {
        const expense_gl = this.parent.expense_gl;
        return parseInt(value) !== expense_gl;
      }
    ).required("Interest Expense cannot be blank"),
  });

  const { values, touched, errors, handleSubmit, setFieldValue } = useFormik({
    initialValues: {
      income_gl: "",
      expense_gl: "",
      asset_gl: "",
      liability_gl: "",
      provision_gl: "",
      tax_gl: "",
      interest_expense_gl: "",
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  useEffect(() => {
    dispatch(getGlAccounts());
  }, []);

  useEffect(() => {
    setAccounting(values);
  }, [values]);


  return (
    <form onSubmit={handleSubmit}>
      <div className='mb-3'>
        {/* <div>
          {errors?.gl && <p className='alert alert-danger'>{errors?.gl}</p>}
        </div> */}
        <div>
          <h4 className='header-title text-uppercase ms-3 text-primary '>
            INCOME GL
          </h4>
        </div>
        <div className='d-flex gap-2  ms-3 mb-3'>
          <label
            htmlFor=''
            className='form-label my-auto'
            style={{ width: "125px" }}
          >
            Income GL 1 <span className='text-danger'>*</span>
          </label>
          <div style={{ width: "100%" }}>
            <Select
              name='income_gl'
              data={gl_accounts?.accounts?.income_account?.map((item) => ({
                label: item?.account_name,
                value: item?.id,
              }))}
              value={values.income_gl}
              onChange={(selectedOption) =>
                setFieldValue("income_gl", selectedOption?.value)
              }
            />
            {errors?.income_gl && touched?.income_gl && (
                <p className='mb-0 text-danger'>
                    {errors?.income_gl + '*'}
                </p>
            )}
          </div>
        </div>
      </div>
      <div>
        <h4 className='header-title text-uppercase ms-3 text-primary '>
          EXPENSE GL
        </h4>
      </div>
      <div className='mb-3'>
        <div className='d-flex gap-2 d-col ms-3 mb-3'>
          <label
            htmlFor=''
            className='form-label my-auto'
            style={{ width: "125px" }}
          >
            Commission
          </label>
          <div style={{ width: "100%" }}>
            <Select
              name='expense_gl'
              data={gl_accounts?.accounts?.expense_account?.map((item) => ({
                label: item?.account_name,
                value: item?.id,
              }))}
              value={values.expense_gl}
              onChange={(selectedOption) =>
                setFieldValue("expense_gl", selectedOption?.value)
              }
            />
          </div>
        </div>
        <div className='d-flex gap-2 d-col ms-3 mb-3'>
          <label
            htmlFor=''
            className='form-label my-auto'
            style={{ width: "125px" }}
          >
            Interest Expense <span className='text-danger'>*</span>
          </label>
          <div style={{ width: "100%" }}>
            <Select
              name='interest_expense_gl'
              data={gl_accounts?.accounts?.expense_account?.map((item) => ({
                label: item?.account_name,
                value: item?.id,
              }))}
              value={values.interest_expense_gl}
              onChange={(selectedOption) =>
                setFieldValue("interest_expense_gl", selectedOption?.value)
              }
            />
            {errors?.interest_expense_gl && touched?.interest_expense_gl && (
              <p className='mb-0 text-danger'>
                  {errors?.interest_expense_gl + '*'}
              </p>
            )}
          </div>
        </div>
      </div>
      <div>
        <h4 className='header-title text-uppercase ms-3 text-primary '>
          ASSET GL
        </h4>
      </div>
      <div className='mb-3'>
        <div className='d-flex gap-2 d-col ms-3 mb-3'>
          <label
            htmlFor=''
            className='form-label my-auto'
            style={{ width: "125px" }}
          >
            Asset GL 1 <span className='text-danger'>*</span>
          </label>
          <div style={{ width: "100%" }}>
            <Select
              name='asset_gl'
              data={gl_accounts?.accounts?.asset_account?.map((item) => ({
                label: item?.account_name,
                value: item?.id,
              }))}
              value={values.asset_gl}
              onChange={(selectedOption) =>
                setFieldValue("asset_gl", selectedOption?.value)
              }
            />
            {errors?.asset_gl && touched?.asset_gl && (
              <p className='mb-0 text-danger'>
                  {errors?.asset_gl + '*'}
              </p>
            )}
          </div>
        </div>
      </div>
      <div>
        <h4 className='header-title text-uppercase ms-3 text-primary '>
          LIABILITY GL
        </h4>
      </div>
      <div className='mb-3'>
        <div className='d-flex gap-2 d-col ms-3 mb-3'>
          <label
            htmlFor=''
            className='form-label my-auto'
            style={{ width: "125px" }}
          >
            Policy Portfolio <span className='text-danger'>*</span>
          </label>
          <div style={{ width: "100%" }}>
            <Select
              name='liability_gl'
              data={gl_accounts?.accounts?.liability_account?.map((item) => ({
                label: item?.account_name,
                value: item?.id,
              }))}
              value={values.liability_gl}
              onChange={(selectedOption) =>
                setFieldValue("liability_gl", selectedOption?.value)
              }
            />
            {errors?.liability_gl && touched?.liability_gl && (
                <p className='mb-0 text-danger'>
                    {errors?.liability_gl + '*'}
                </p>
            )}
          </div>
        </div>
      </div>
      <div>
        <h4 className='header-title text-uppercase ms-3 text-primary '>
          PROVISION GL
        </h4>
      </div>
      <div className='mb-3'>
        {/* <h2 style={{ fontSize: "14px" }} className='text-primary'>
          PROVISION GL
        </h2> */}
        <div className='d-flex gap-2 d-col ms-3 mb-3'>
          <label
            htmlFor=''
            className='form-label my-auto'
            style={{ width: "125px" }}
          >
            Provision GL 1
          </label>
          <div style={{ width: "100%" }}>
            <Select
              name='provision_gl'
              data={gl_accounts?.accounts?.provision_account?.map((item) => ({
                label: item?.account_name,
                value: item?.id,
              }))}
              value={values.provision_gl}
              onChange={(selectedOption) =>
                setFieldValue("provision_gl", selectedOption?.value)
              }
            />
          </div>
        </div>
      </div>
      <div>
        <h4 className='header-title text-uppercase ms-3 text-primary '>
          TAX GL
        </h4>
      </div>
      <div className='mb-3'>
        <div className='d-flex gap-2 d-col ms-3 mb-3'>
          <label
            htmlFor=''
            className='form-label my-auto'
            style={{ width: "125px" }}
          >
            Tax GL 1
          </label>
          <div style={{ width: "100%" }}>
            <Select
              name='tax_gl'
              data={gl_accounts?.accounts?.tax_account?.map((item) => ({
                label: item?.account_name,
                value: item?.id,
              }))}
              value={values.tax_gl}
              onChange={(selectedOption) =>
                setFieldValue("tax_gl", selectedOption?.value)
              }
            />
          </div>
        </div>
      </div>

      <div className='mt-4 d-flex justify-content-end'>
        <button
          type='button'
          className='btn btn-info text-white me-3'
          onClick={() => interestRef?.current?.click()}
        >
          <i className='mdi mdi-arrow-left me-1'></i>
          Previous
        </button>
        <button type='submit' className='btn btn-primary text-white '>
          Next <i className='mdi mdi-arrow-right ms-1'></i>
        </button>
      </div>
    </form>
  );
};

export default SavingsAccounting;
